import axios from 'axios';

const pending = {};
const cache = {};
const CACHE_TTL = 30000; // 30 seconds

export function cachedGet(url, config = {}) {
  const cacheKey = url;
  const ttl = config.cacheTime || CACHE_TTL;
  const now = Date.now();
  if (cache[cacheKey] && (now - cache[cacheKey].ts) < ttl) {
    return Promise.resolve({ data: cache[cacheKey].data });
  }
  if (pending[cacheKey]) return pending[cacheKey];
  pending[cacheKey] = axios.get(url, { withCredentials: config.withCredentials }).then(res => {
    cache[cacheKey] = { data: res.data, ts: Date.now() };
    delete pending[cacheKey];
    return res;
  }).catch(err => {
    delete pending[cacheKey];
    throw err;
  });
  return pending[cacheKey];
}

export function invalidateCache(url) {
  if (url) delete cache[url];
  else Object.keys(cache).forEach(k => delete cache[k]);
}
